export function assignDestinationIds(destinations) {
  if (!Array.isArray(destinations)) return destinations;

  destinations.forEach((destination, index) => {
    if (destination && destination.id !== index) {
      destination.id = index;
    }
  });

  return destinations;
}
